import axios from './axios';
import { IResponse } from '@shared-components/models';
import { API_URL } from '@moxie/constants';

const getTenantRoles = async (): Promise<IResponse> => {
  return axios.get(`${API_URL.CRM_ROLE}`);
};

export { getTenantRoles };
